import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default from 'react';
import BaseMenu from '../616495e5c31461ab4eaac58b9ea871e3dd3588fd9e2290cfc7ec11f04b9dea24.cfe-internal.js';

var _excluded = ["selectable", "onSelectedValueChange", "onChange"];
var SelectMenu = /*#__PURE__*/React__default.forwardRef(function SelectMenu(_ref, ref) {
  _ref.selectable;
      var _onSelectedValueChange = _ref.onSelectedValueChange,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(BaseMenu, _extends({
    ref: ref,
    menuType: SelectMenu,
    selectable: true,
    onSelectedValueChange: function onSelectedValueChange(value) {
      var _context;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _onSelectedValueChange === null || _onSelectedValueChange === void 0 ? void 0 : _onSelectedValueChange.apply(void 0, _concatInstanceProperty(_context = [value]).call(_context, args));
      onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }
  }, rest));
});
var SelectMenu$1 = SelectMenu;

export { SelectMenu$1 as default };
